<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;">

          <div style="margin: 20px;font-size: 28px;font-weight: bold;text-align: center;">老师的5个减负免费效率工具</div>

          <div style="display: flex;justify-content: space-evenly;">
            <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">发分班、发工资条</div>
              <div
                style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
              </div>
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">万能快查小程序</div>
              <div style="display: flex;justify-content: center;"><img src="../assets/wansearch_weixin.jpg"
                  style="width: 150px;height:150px;"></img></div>
              <div style="font-weight: bold;margin-top: 10px;">
                <!--            <div style="margin-bottom: 5px;">用途：可设置任意查询条件的查询系统</div> -->
                <div style="margin-bottom: 5px;">特点：</div>
                <div style="margin-bottom: 5px;">1.查询条件可以任意设置</div>
                <div style="margin-bottom: 5px;">2.适用于发分班、工资条等</div>
                <div style="margin-bottom: 5px;">3.可加入公众号，海报等</div>
              </div>
            </div>

            <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">核对数据、补填资料
              </div>
              <div
                style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
              </div>

              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">核对信息小程序</div>
              <div style="display: flex;justify-content: center;"><img src="../assets/hdxx_qrcode.jpg"
                  style="width: 150px;height:150px;"></img></div>
              <div style="font-weight: bold;margin-top: 10px;">
                <!-- <div style="margin-bottom: 5px;">用途：可核对任何Excel文件中数据</div> -->
                <div style="margin-bottom: 5px;">特点：</div>
                <div style="margin-bottom: 5px;">1.一对一核对安全保密</div>
                <div style="margin-bottom: 5px;">2.可补填、可修改，修改可留痕</div>
                <div style="margin-bottom: 5px;">3.查询条件可任意定制</div>
              </div>
            </div>

            <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">师德师风、打分测评
              </div>

              <div
                style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
              </div>

              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">打分测评小程序</div>
              <div style="display: flex;justify-content: center;"><img src="../assets/dfcp_qrcode.jpg"
                  style="width: 150px;height:150px;"></img></div>
              <div style="font-weight: bold;margin-top: 10px;">
                <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
                <div style="margin-bottom: 5px;">特点：</div>
                <div style="margin-bottom: 5px;">1.一对一打分安全保密</div>
                <div style="margin-bottom: 5px;">2.可实名、可匿名</div>
                <div style="margin-bottom: 5px;">3.打分结果自动计算汇总</div>
              </div>
            </div>

            <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">在线收集、学籍填报
              </div>

              <div
                style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
              </div>

              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">多人填表小程序</div>
              <div style="display: flex;justify-content: center;"><img src="../assets/drtb_qrcode.jpg"
                  style="width: 150px;height:150px;"></img></div>
              <div style="font-weight: bold;margin-top: 10px;">
                <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
                <div style="margin-bottom: 5px;">特点：</div>
                <div style="margin-bottom: 5px;">1.互不查看，安全保密</div>
                <div style="margin-bottom: 5px;">2.只填自己的，防止改错</div>
                <div style="margin-bottom: 5px;">3.数据格式规范，一键导出</div>
              </div>
            </div>


            <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">评优评先、民主投票
              </div>

              <div
                style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
              </div>

              <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">闲鸟投票小程序</div>
              <div style="display: flex;justify-content: center;"><img src="../assets/xntp_qrcode.jpg"
                  style="width: 150px;height:150px;"></img></div>
              <div style="font-weight: bold;margin-top: 10px;">
                <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
                <div style="margin-bottom: 5px;">特点：</div>
                <div style="margin-bottom: 5px;">1.一次投完，避免多次发起投票；</div>
                <div style="margin-bottom: 5px;">2.投票自动统计；</div>
                <div style="margin-bottom: 5px;">3.一个微信一票，拒绝刷票.</div>
              </div>
            </div>

          </div>


        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/tools.vue